import React from "react";
import { Button } from "@mui/material";
import { focusRing, tokens } from "../../utils/figmaTokens";

// Button, size S (047 kit; the states' buttons 10601:492, the ticket composer 10829:93565): 8 px
// padding and radius, 12/16 text, 18 px icons 8 px from the text. `solid` is brand blue, `outline`
// has the neutral 1.5 px border inside the same box, `ghost` has neither. A button with no text
// is named by `label`. Anything else (onClick, disabled, component and to) goes to the Button.
// Keyboard focus shows D22's ring, not MUI's grey focus ripple (047 D73).
const base = { p: "8px", minWidth: 0, gap: "8px", borderRadius: "8px", fontSize: 12, lineHeight: "16px", fontWeight: 500, ...focusRing };

const TONES = {
  solid: { variant: "contained", sx: base },
  outline: {
    variant: "outlined",
    sx: {
      ...base,
      p: "6.5px",
      border: `1.5px solid ${tokens.buttonBorder}`,
      color: tokens.text.primary,
      "&:hover": { border: `1.5px solid ${tokens.buttonBorder}`, bgcolor: tokens.hover },
      "&.Mui-disabled": { border: `1.5px solid ${tokens.border.strong}`, color: tokens.text.disabled },
    },
  },
  ghost: { variant: "text", sx: { ...base, color: tokens.text.primary, "&:hover": { bgcolor: tokens.hover } } },
};

const SmallButton = ({ tone = "outline", Icon, EndIcon, label, children, sx, ...rest }) => {
  const look = TONES[tone] || TONES.outline;
  return (
    <Button variant={look.variant} aria-label={children ? undefined : label} disableFocusRipple sx={{ ...look.sx, ...sx }} {...rest}>
      {Icon && <Icon size={18} aria-hidden />}
      {children}
      {EndIcon && <EndIcon size={18} aria-hidden />}
    </Button>
  );
};

export default SmallButton;
